import React, { Component } from "react";
import Collapsible from "react-collapsible";
import '../assets/templates/DoubleSentence.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowClose, faArrowAltCircleDown } from '@fortawesome/free-solid-svg-icons'
import LessonInstruction from "../containers/instruction/LessonInstruction";


class ListenSpeak extends Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
      openSecond: false,
      index: 0
    }
  }

  componentDidUpdate(prevProps, prevState){
    if(prevProps.contentIndex !== this.props.contentIndex){
      this.setState({
        open: false,
      })
    }
  }

  _reset(){
    this.setState({
      open: false
    })
  }

  render() {
    const { data, audioUrl } = this.props;
    
    // temporary - sets background to white color
    const bgColor = data.type === "instruction" ? "new-bg-color" : "";
    const containerClasses = `default-card ${bgColor}`;

    return (
      <div className={containerClasses}>
      <div>
      </div>
            {
              data.type === 'instruction'
                ?
                <>
                  <LessonInstruction
                    instructionText={data.instruction}
                    audioUrl={audioUrl}
                  />
                </>
                :
                <div>
                    <h2>
                    <Collapsible 
                    triggerTagName="div" 
                    className="collapse-opened" 
                    trigger={data.en}
                    open={this.state.open}
                    handleTriggerClick={()=>this.setState({ open: !this.state.open })}
                    onClosing={()=>{this.setState({ isClosing: true })}}
                    onOpening={()=>{this.setState({ isClosing: false })}}
                    >
                    { !this.state.isClosing ? data.pt : null }
                    </Collapsible>
                  </h2>
                  <div className="highlight-icon-container">
                        <div className="highlight-icon" onClick={()=>{this.setState({ open: !this.state.open })}}>
                            <FontAwesomeIcon className="icon-step" icon= {this.state.open === false ?  faArrowAltCircleDown     :  faWindowClose  } />
                        </div>
                    </div>
                </div>
            }
          
      </div>
    )
  }
}

export default ListenSpeak;
